import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import CONSTANTS from '../constants';
import DeliveryChargeHelper from './DeliveryChargeHelper';

export default class GoogleHelper {
  static async getLatLongFromAddress(address) {
    let geoCodedLocation = (await geocodeByAddress(address))[0];
    return getLatLng(geoCodedLocation);
  }

  static setCheckForDelivery(data) {
    localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_ask_location`, data);
  }

  static getCheckForDelivery() {
    localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_ask_location`);
  }

  static getDeliveryArea(locationString, deliveryAreas, orderTotal) {

    let [lat, lng] = locationString.split(',');
    let location = { lat, lng };
    if (deliveryAreas.length > 0) {
      let areas = deliveryAreas.filter((area) => {
        if (area.status) {
          if (area.type === CONSTANTS.ORDERS.VARIABLES.DELIVERY_ZONE_TYPES.CIRCLE)
            return this.isInsideCircle(location, area);
          if (area.type === CONSTANTS.ORDERS.VARIABLES.DELIVERY_ZONE_TYPES.SHAPE)
            return this.isInsideShape(location, area);
          return false;
        } else {
          return false;
        }
      });
      if (areas) {
        //if (orderTotal) {
        if (areas.length > 0) {
          areas.forEach(
            (area) =>
              (area.deliveryCharges = DeliveryChargeHelper.computeDeliveryCharges(area, orderTotal))
          );
          areas.sort((a, b) => a.deliveryCharges - b.deliveryCharges);
          //}
          return areas[0];
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  static distanceBetweenTwoLatLngStrings(point1Str, point2Str) {
    const [lat1, lng1] = point1Str.split(',');
    const [lat2, lng2] = point2Str.split(',');
    const point1 = new window.google.maps.LatLng(lat1, lng1);
    const point2 = new window.google.maps.LatLng(lat2, lng2);
    return Math.round(parseFloat(this.distance(point1, point2) / 1000));
  }

  static distance(point1, point2) {
    return window.google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
  }

  static isInsideCircle(location, circle) {
    let circleInfo = circle.circle;
    let center = new window.google.maps.LatLng(circleInfo[0].center.lat, circleInfo[0].center.lng);
    let latLng = new window.google.maps.LatLng(location.lat, location.lng);
    return this.distance(latLng, center) < circleInfo[1].radius;
  }

  static isInsideShape(location, shape) {
    if (window.google) {
      let latLng = new window.google.maps.LatLng(location.lat, location.lng);
      let mapShape = new window.google.maps.Polygon({ paths: shape.vertices });
      return window.google.maps.geometry.poly.containsLocation(latLng, mapShape);
    }
  }
}
